module.exports = __webpack_public_path__ + "Employee Guide to COBRA.pdf";